import React from 'react';
import { connect } from 'react-redux';
import UploadPhoto from '../../../../../../common/components/UploadPhoto/UploadPhoto';
import { Form, Input } from 'antd';
import { UPLOAD_EMPLOYEE_PHOTO } from '../../../../api/constants';

const UserName = ({ isEditable, validateField, form, profileId }) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const validateLastName = validateField('lastname');
  const validateName = validateField('name');
  const validatePatronymic = validateField('patronymic');
  const employeeId = getFieldValue('profileId');
  return (
    <div className="b-form-fields">
      <div className="b-form-fields__item">
        <Form.Item
          label="Фамилия"
          validateStatus={validateLastName.status}
          help={validateLastName.help}
        >
          {getFieldDecorator('lastname', {
            rules: [
              {
                required: true,
                message: 'Поле, обязательное для заполнения',
              },
            ],
          })(
            <Input
              name="lastname"
              style={{ width: 224 }}
              placeholder="Укажите фамилию"
              disabled={!isEditable}
            />
          )}
        </Form.Item>
        <div className="b-form-fields__item-photo">
          <Form.Item>
            {getFieldDecorator('photo', {
              rules: [],
              valuePropName: 'image_url',
            })(
              <UploadPhoto
                disabled={!isEditable}
                name={'photo'}
                data={{ profile_id: profileId, employee_id: employeeId }}
                action={
                  employeeId && employeeId > 0 ? UPLOAD_EMPLOYEE_PHOTO : null
                }
                update={
                  employeeId && employeeId > 0
                    ? null
                    : file => setFieldsValue({ photo: file })
                }
              />
            )}
          </Form.Item>
        </div>
      </div>
      <div className="b-form-fields__item">
        <Form.Item
          label="Имя"
          validateStatus={validateName.status}
          help={validateName.help}
        >
          {getFieldDecorator('name', {
            rules: [
              {
                required: true,
                message: 'Поле, обязательное для заполнения',
              },
            ],
          })(
            <Input
              name="name"
              style={{ width: 224 }}
              placeholder="Укажите имя"
              disabled={!isEditable}
            />
          )}
        </Form.Item>
      </div>
      <div className="b-form-fields__item  middleNameBlock">
        <Form.Item
          label={<span className="field__title">Отчество</span>}
          validateStatus={validatePatronymic.status}
          help={validatePatronymic.help}
        >
          {getFieldDecorator('patronymic')(
            <Input
              name="patronymic"
              style={{ width: 224 }}
              placeholder="Укажите отчество"
              disabled={!isEditable}
            />
          )}
        </Form.Item>
      </div>
    </div>
  );
};

export default connect(state => ({
  profileId: state.Authorization.activeProfile.profileId,
}))(UserName);
